if (typeof ProductBundler != "function") {
  class ProductBundler2 extends HTMLElement {
    constructor() {
      super();
      console.log('ProductBundler2 constructor called');

      const cssSlider = this.querySelector("css-slider");
      cssSlider
        ? cssSlider.addEventListener("ready", () => this.init())
        : this.init();
    } 

    init() {
      const discountScript = document.getElementById("bundle-discounts-json");
      if (discountScript) {
        try {
          this.discountRules = JSON.parse(discountScript.textContent || "[]").sort((a, b) => b.min - a.min);
        } catch (e) {
          console.warn("Invalid discount JSON", e);
          this.discountRules = [];
        }
      } else {
        this.discountRules = [];
      }
      this.initBundler();
      this.initProducts();
      this.updateBundlePrices();
      this.updateStepProgress();
    }

    updateItemCount() {
      const counter = this.querySelector("#item-number");
      if (!counter || !Array.isArray(this.bundleProducts)) return;
    
      const count = this.bundleProducts.filter(
        (elm) => !elm.classList.contains("bundler-product--empty")
      ).length;
    
      counter.textContent = count;
    
      const addButton = this.querySelector("[data-js-add-bundle-to-cart]");
      const meetsMinimum = !this._bundleMin || count >= this._bundleMin;
  
      if (addButton) {
        addButton.disabled = !meetsMinimum;
      }
      if (meetsMinimum) {
        this.classList.add("bundler-full");
      } else {
        this.classList.remove("bundler-full");
      }
    }
    
    updateStepProgress() {
      const stepsTextEl = this.querySelector(".steps_bundles_text");
      const stepsContainer = this.querySelector(".steps_bundles");
      if (!stepsTextEl || !stepsContainer || !this.discountRules || this.discountRules.length === 0) return;

      const itemCount = this.bundleProducts.filter(elm => !elm.classList.contains("bundler-product--empty")).length;
      stepsContainer.innerHTML = "";

      let nextStep = null;
      const sortedRules = [...this.discountRules].sort((a, b) => a.min - b.min);

      sortedRules.forEach((rule, index) => {
        const stepEl = document.createElement("div");
        stepEl.classList.add("bundle-step");

        const isAchieved = itemCount >= rule.min;
        const isActive = !nextStep && !isAchieved;

        if (isAchieved) {
          stepEl.classList.add("done");
          stepEl.style.setProperty("--progress", "100%");
        } else if (isActive) {
          stepEl.classList.add("active");

          // Determine how much progress user has made toward this step
          const prevMin = index > 0 ? sortedRules[index - 1].min : 0;
          const progressFraction = (itemCount - prevMin) / (rule.min - prevMin);
          const progressPercent = Math.max(0, Math.min(100, Math.round(progressFraction * 100)));

          stepEl.style.setProperty("--progress", `${progressPercent}%`);
          nextStep = rule;
        } else {
          // Not yet reached, no progress
          stepEl.style.setProperty("--progress", "0%");
        }

        stepsContainer.appendChild(stepEl);
      });

      if (nextStep) {
        const productsNeeded = Math.max(0, nextStep.min - itemCount);
        const discountPercent = (nextStep.discount * 100).toFixed(0);
        const textTemplate = KROWN.settings.locales.products_bundle_step || 'Add {X} products to get {Y}% off';
        const text = textTemplate.replace('{X}', productsNeeded).replace('{Y}', discountPercent);
        stepsTextEl.textContent = text;
      } else {
        const unlockedText = KROWN.settings.locales.products_bundle_max_discount || 'You’ve unlocked the maximum discount! 🎉';
        stepsTextEl.textContent = unlockedText;
      }
    }

    getCurrentDiscount() {
      const itemCount = this.bundleProducts?.filter(elm => !elm.classList.contains("bundler-product--empty")).length || 0;
      for (const rule of this.discountRules) {
        if (itemCount >= rule.min) return rule.discount;
      }
      return 0;
    }

    formatCurrency(amountInCents) {
      const amount = amountInCents / 100;
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
    }

    calculateTotalPrice() {
      const discount = this.getCurrentDiscount();
      let total = 0;
      this.bundleProducts.forEach((slot) => {
        if (slot.classList.contains("bundler-product--empty")) return;
        const product = slot.product;
        const priceEl = product?.querySelector("[data-js-quick-buy-product-price]");
        if (!priceEl) return;
        const priceText = priceEl.textContent.trim();
        const rawPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        total += rawPrice * (1 - discount);
      });
      return total;
    }

    updateBundlePrices() {
      const discount = this.getCurrentDiscount();
      this.bundleProducts.forEach((slot) => {
        if (slot.classList.contains("bundler-product--empty")) return;
        const product = slot.product;
        const priceEl = product?.querySelector("[data-js-quick-buy-product-price]");
        if (!priceEl) return;
        const priceText = priceEl.textContent.trim();
        const rawPrice = parseFloat(priceText.replace(/[^0-9,]/g, '').replace(',', '.'));
        const discountedPrice = rawPrice * (1 - discount);
        const discountPercentText = discount > 0
          ? `<span class="bundler-product__price-discount">-${(discount * 100).toFixed(0)}%</span>` : '';
        const displayPrice = discount > 0
          ? `<span class="bundler-product__price-original">${this.formatCurrency(Math.round(discountedPrice * 100))}</span>
             <s class="bundler-product__price-discounted">${this.formatCurrency(Math.round(rawPrice * 100))}</s>
             ${discountPercentText}`
          : `<span class="bundler-product__price-regular">${this.formatCurrency(Math.round(rawPrice * 100))}</span>`;
        slot.querySelector("[data-js-bundler-product-price]").innerHTML = displayPrice;
      });

      let originalTotal = 0;
      let discountedTotal = 0;
      this.bundleProducts.forEach((slot) => {
        if (slot.classList.contains("bundler-product--empty")) return;
        const product = slot.product;
        const priceEl = product?.querySelector("[data-js-quick-buy-product-price]");
        if (!priceEl) return;
        const priceText = priceEl.textContent.trim();
        const rawPrice = parseFloat(priceText.replace(/[^0-9,]/g, '').replace(',', '.'));
        const discountedPrice = rawPrice * (1 - discount);
        originalTotal += rawPrice;
        discountedTotal += discountedPrice;
      });

      const totalSpan = this.querySelector("#total_bundle");
      if (totalSpan) {
        if (discount > 0) {
          totalSpan.innerHTML = `<span>${this.formatCurrency(Math.round(discountedTotal * 100))}</span>
            <s class="bundler-product__price-discounted">${this.formatCurrency(Math.round(originalTotal * 100))}</s>`;
        } else {
          totalSpan.innerHTML = `<span class="bundler-product__price-regular">${this.formatCurrency(Math.round(originalTotal * 100))}</span>`;
        }
      }
    }

    initBundler() {
      this._bundleMin = parseInt(this.dataset.minimum);
      this._bundleMax = parseInt(this.dataset.limitMaximum) || null;
      this._bundleTemplate = this.querySelector("[data-js-bundler-product]").cloneNode(true);

      this.querySelectorAll("[data-js-bundler-product-remove]").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          this.clearSlot(e.target.closest("[data-js-bundler-product]"));
        });
      });

      this.querySelector("[data-js-bundler-toggle]").addEventListener("click", () => {
        if (window.innerWidth < 768) this.classList.toggle("opened");
      });

      this.querySelector("[data-js-add-bundle-to-cart]").addEventListener("click", async () => {
        const bundledCount = this.bundleProducts.filter(elm => !elm.classList.contains("bundler-product--empty")).length;
        if (this._bundleMin && bundledCount < this._bundleMin) {
          alert(`Please add at least ${this._bundleMin} product${this._bundleMin > 1 ? 's' : ''} to complete the bundle.`);
          return;
        }

        const items = [];
        this.bundleProducts.forEach((elm) => {
          if (elm.dataset.id) {
            const existing = items.find(item => item.id === elm.dataset.id);
            if (existing) {
              existing.quantity++;
            } else {
              items.push({ id: elm.dataset.id, quantity: 1 });
            }
          }
        });

        if (items.length === 0) return;

        const submitButton = this.querySelector("[data-js-add-bundle-to-cart]");
        submitButton.classList.add("working");

        try {
          const formData = new FormData();
          formData.append('sections_url', window.location.pathname);
          const sectionsToRender = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToRender }
          }));
          formData.append('sections', sectionsToRender);
          items.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });

          const config = theme.utils.fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(theme.routes.cart_add_url, config);
          const parsedState = await response.json();
          if (parsedState.status) throw new Error(parsedState.message || parsedState.description);

          const cartResponse = await fetch(theme.routes.cart_url, theme.utils.fetchConfig());
          const cartJson = await cartResponse.json();
          cartJson.sections = parsedState.sections;

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));

          this.querySelectorAll("[data-js-bundler-product]").forEach((elm) => this.clearSlot(elm));
          this.classList.remove("opened");

          if (window.cartDrawer?.show) {
            window.cartDrawer.show();
          } else {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer?.show instanceof Function) {
              cartDrawer.show();
            } else {
              document.body.classList.add('has-modal-open');
              if (cartDrawer) {
                cartDrawer.removeAttribute('inert');
                cartDrawer.removeAttribute('hidden');
                cartDrawer.setAttribute('open', '');
                cartDrawer.setAttribute('active', '');
              }
            }
          }

        } catch (error) {
          console.error('Add to cart error:', error);
          alert('Failed to add bundle to cart. Please try again.');
        } finally {
          submitButton.classList.remove("working");
        }
      });
    }

    initProducts() {
      console.log('initProducts running');
      this.bundleProducts = [...this.querySelectorAll("[data-js-bundler-product]")];

      this.querySelectorAll("form[data-type='add-to-cart-form']").forEach((form) => {
        if (!form.hasAttribute("data-init")) {
          form.querySelector("[data-js-product-add-to-cart]").addEventListener("click", (e) => {
            const productItem = form.closest("[data-js-product-item]");
            const buttonText = form.querySelector("[data-js-product-add-to-cart-text]");
            if (buttonText) {
              buttonText.textContent = KROWN.settings.locales.products_added_to_bundle_label || "Added to bundle";
              buttonText.classList.add("added");
            }

            const variantId = form.querySelector("input[name='id']")?.value;
            if (!variantId) return;

            let variant = null;
            const variantsEl = productItem.querySelector("product-variants");
            variant = variantsEl?.currentVariant || { id: variantId, title: "" };

            this.addToBundle(variant, productItem);
            this.updateItemCount();
            this.updateBundlePrices();
            this.updateStepProgress();
          });

          form.setAttribute("data-init", "true");
        }
      });

      this.updateItemCount();
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm => elm.classList.contains("bundler-product--empty"));
    }

    clearSlot(slot) {
      const product = slot.product;
    
      const buttonText = product?.querySelector("[data-js-product-add-to-cart-text]");
      if (buttonText) {
        buttonText.textContent = KROWN.settings.locales.products_add_to_bundle_button;
        buttonText.classList.remove("added");
      }
    
      product?.classList.remove("product-item--bundled");
    
      // Read min slots from data attribute
      const minSlots = parseInt(this.dataset.slots) || 3; // fallback to 3 if missing
      const slotIndex = this.bundleProducts.indexOf(slot);
      const isStaticSlot = slotIndex < minSlots;
    
      if (isStaticSlot) {
        // Reset slot for initial placeholders
        slot.classList.add("bundler-product--empty");
        slot.dataset.id = "";
        slot.dataset.variant = null;
        slot.product = null;
        slot.querySelector("[data-js-bundler-product-text]").innerHTML = "";
        slot.querySelector("[data-js-bundler-product-price]").innerHTML = "";
        slot.querySelector("[data-js-bundler-product-image]").innerHTML = "";
      } else {
        // Remove dynamically added slots
        slot.remove();
        this.bundleProducts.splice(slotIndex, 1);
      }
    
      if (this.findEmptySlot()) this.classList.remove("bundler-full");
      this.reorderSlots();
      this.updateItemCount();
      this.updateBundlePrices();
      this.updateStepProgress();
    }


    reorderSlots() {
      let ei = 0, fi = -100;
      this.querySelectorAll("[data-js-bundler-product]").forEach((elm) => {
        elm.style.order = elm.classList.contains("bundler-product--empty") ? ei++ : fi++;
      });
    }

    createSlot() {
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector("[data-js-bundler-product-remove]").addEventListener("click", (e) => {
        this.clearSlot(e.target.closest("[data-js-bundler-product]"));
      });
      this.querySelector("[data-js-bundler-products]").appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {
      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector("[data-js-quick-buy-product-image]").textContent;

      if (!slot && this._bundleMax && this.bundleProducts.length < this._bundleMax) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if (!slot) return;

      slot.classList.remove("bundler-product--empty");

      slot.querySelector("[data-js-bundler-product-price]").innerHTML = `
        <span class="bundler-product__text-price price-current text-line-height--medium text-weight--bold">
          ${product.querySelector("[data-js-quick-buy-product-price]").textContent}
        </span>`;

      slot.querySelector("[data-js-bundler-product-text]").innerHTML = `
        <span class="bundler-product__text-title text-line-height--medium text-weight--bold">
          ${product.querySelector("[data-js-quick-buy-product-title]").textContent}
        </span>
        ${
          product.querySelector("product-variants")?.hasAttribute("data-has-variants")
            ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>`
            : ""
        }`;

      slot.querySelector("[data-js-bundler-product-image]").innerHTML = `
        <img src="${this.getResizedImageSrc(imageSrc, 60)}"
          srcset="
            ${this.getResizedImageSrc(imageSrc, 60)} 60w,
            ${this.getResizedImageSrc(imageSrc, 120)} 120w,
            ${this.getResizedImageSrc(imageSrc, 180)} 180w"
          sizes="60px"
        />`;

      if (this.hasAttribute("data-limit-bundles")) {
        product.classList.add("product-item--bundled");
      }

      slot.product = product;
      slot.dataset.id = product.querySelector('input[name="id"]').value;
      slot.dataset.variant = variant;

      const bundledCount = this.bundleProducts.filter(elm => !elm.classList.contains("bundler-product--empty")).length;
      if (this._bundleMax && bundledCount >= this._bundleMax) {
        this.classList.add("bundler-full");
      } else {
        this.classList.remove("bundler-full");
      }
    }

    getResizedImageSrc(src, size, crop = "center") {
      return `${src}${src.includes("?") ? "&" : "?"}width=${size}&height=${size}&crop=${crop}`.replace(/\n|\r|\s/g, "");
    }
  }

  if (typeof customElements.get("product-bundler") === "undefined") {
    customElements.define("product-bundler", ProductBundler2);
  }
}
